export default "__VITE_ASSET__CLKXbTt0__"